import Configurazioni from "../";

const routes = [{ name: "ConfigurazioniPage", path: "/configurazioni", component: Configurazioni.ConfigurazioniPage }];

export default routes;
